import { jsx as n } from "react/jsx-runtime";
import { UserMenuInfoItemContainer as m, UserMenuInfoItemContainerSecondary as f } from "./style.js";
import { UserMenuInfoContainer as C } from "./style.js";
import { ConditionalLink as I } from "../ConditionalLink/index.js";
function d({
  label: o,
  onClick: r,
  isDanger: e,
  url: t,
  ...i
}) {
  return /* @__PURE__ */ n(I, { url: t, children: /* @__PURE__ */ n(
    m,
    {
      onClick: r,
      as: e && f || void 0,
      ...i,
      children: o
    }
  ) });
}
export {
  C as UserMenuInfoContainer,
  d as UserMenuInfoItem,
  m as UserMenuInfoItemContainer
};
